export default "__VITE_ASSET__DU0ss4S$__"